import { createToken } from '@react-apps/core';
import type { GuaranteeRepositoryImpl } from '../data/repositories/guarantee.repository.impl';

export const GuaranteeRepositoryToken = createToken<GuaranteeRepositoryImpl>(
  'GuaranteeRepository',
);
